/**
 * Split a SQL/KQL expression on a top-level separator (e.g. ` AND `, ` OR `).
 *
 * A naive String.split(` ${operator} `) breaks values that contain the
 * operator word inside a quoted literal — e.g. `name == "Analytics and Reports"`
 * would be split on the inner ` and `. This walks the string while tracking
 * quote state and parenthesis depth, and only splits at depth 0 outside quotes.
 */
export function splitOnTopLevelOperator(
  sql: string,
  operator: string,
): string[] {
  const sep = ` ${operator} `;
  const parts: string[] = [];
  let depth = 0;
  let openingStrChar: string | undefined;
  let start = 0;
  let i = 0;
  while (i < sql.length) {
    const ch = sql[i];
    if (openingStrChar) {
      if (ch === '\\' && i + 1 < sql.length) {
        i += 2;
        continue;
      }
      if (ch === openingStrChar) {
        openingStrChar = undefined;
      }
      i += 1;
      continue;
    }
    if (ch === '"' || ch === "'" || ch === '`') {
      openingStrChar = ch;
      i += 1;
      continue;
    }
    if (ch === '(') {
      depth += 1;
      i += 1;
      continue;
    }
    if (ch === ')') {
      depth -= 1;
      i += 1;
      continue;
    }
    if (
      depth === 0 &&
      i + sep.length <= sql.length &&
      sql.substring(i, i + sep.length) === sep
    ) {
      parts.push(sql.substring(start, i));
      i += sep.length;
      start = i;
      continue;
    }
    i += 1;
  }
  parts.push(sql.substring(start));
  return parts;
}
